import React from 'react';
import { CollectionFormModalProvider } from '../state/CollectionFormModalProvider';
import CookiebotContextProvider from '../state/CookiebotContextProvider';
import { ManageItemInCollectionModalProvider } from '../state/ManageItemInCollectionModalProvider';
import { ManageItemInCollectionProvider } from '../state/ManageItemInCollectionProvider';
import { ModalsProvider } from '../state/ModalsProvider';
import { SnackbarContextProvider } from '../state/SnackbarContextProvider';
import { SearchFiltersDialogProvider } from '../state/SearchFiltersDialogProvider';
import { RouterProvider } from '../utils/useRouter';
import { MasterLayoutProvider } from '../state/MasterLayoutProvider';
import AIAssistantProvider from '../state/AIAssistantContextProvider';
import { NotificationProvider } from '../state/NotificationContextProvider';
import ReaderContextProvider from '../components/Reader/ReaderContext';
const contexts: (React.FC | React.ComponentType)[] = [
  NotificationProvider,
  RouterProvider,
  CookiebotContextProvider,
  CollectionFormModalProvider,
  ManageItemInCollectionProvider,
  ManageItemInCollectionModalProvider,
  ModalsProvider,
  SnackbarContextProvider,
  SearchFiltersDialogProvider,
  MasterLayoutProvider,
  ReaderContextProvider,
  AIAssistantProvider
];

const Contexts: React.FC = (props) => (
  <>
    {contexts.reduceRight((previous, Current) => (
      <Current>
        {previous}
      </Current>
    ), props.children)}
  </>
);

export default Contexts;
